import { render, staticRenderFns } from "./QuotationTableForLazyLoadingWithResize.vue?vue&type=template&id=da6f5978&scoped=true"
import script from "./QuotationTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"
export * from "./QuotationTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6f5978",
  null
  
)

export default component.exports